import React from 'react';
import {
  ShoppingCartIcon as HeroShoppingCartIcon,
  BellIcon as HeroBellIcon,
  MagnifyingGlassIcon as HeroMagnifyingGlassIcon,
  ChevronDownIcon as HeroChevronDownIcon,
  ExclamationTriangleIcon as HeroExclamationTriangleIcon,
  ArrowLeftStartOnRectangleIcon as HeroArrowLeftStartOnRectangleIcon,
  Squares2X2Icon as HeroSquares2X2Icon,
} from '@heroicons/react/24/outline';

/**
 * Iconos para el componente Navbar
 * Basados en Heroicons 24/outline
 *
 * @see docs/icons.md - Sistema de iconos
 */

/** Icono de carrito de compras */
export const ShoppingCartIcon: React.FC<{ className?: string }> = ({ className = 'size-4' }) => (
  <HeroShoppingCartIcon className={className} aria-hidden="true" />
);

/** Icono de campana para notificaciones */
export const BellIcon: React.FC<{ className?: string }> = ({ className = 'size-4' }) => (
  <HeroBellIcon className={className} aria-hidden="true" />
);

/** Icono de lupa para búsqueda */
export const MagnifyingGlassIcon: React.FC<{ className?: string }> = ({ className = 'size-4' }) => (
  <HeroMagnifyingGlassIcon className={className} aria-hidden="true" />
);

/** Icono de chevron abajo para el dropdown de usuario */
export const ChevronDownIcon: React.FC<{ className?: string }> = ({ className = 'size-5' }) => (
  <HeroChevronDownIcon className={className} aria-hidden="true" />
);

/** Icono de advertencia para el badge de ambiente */
export const ExclamationTriangleIcon: React.FC<{ className?: string }> = ({ className = 'size-4' }) => (
  <HeroExclamationTriangleIcon className={className} aria-hidden="true" />
);

/** Icono de cerrar sesión / navegación */
export const ArrowLeftStartOnRectangleIcon: React.FC<{ className?: string }> = ({ className = 'size-4' }) => (
  <HeroArrowLeftStartOnRectangleIcon className={className} aria-hidden="true" />
);

/** Icono de cuadrícula 2x2 para el lanzador de aplicaciones (AppLauncher) */
export const Squares2X2Icon: React.FC<{ className?: string }> = ({ className = 'size-6' }) => (
  <HeroSquares2X2Icon className={className} aria-hidden="true" />
);

/** Punto indicador de notificación */
export const NotificationDot: React.FC<{ className?: string }> = ({ className = 'size-2' }) => (
  <svg className={className} viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4" cy="4" r="4" fill="currentColor" />
  </svg>
);